var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 65,
    viewBox: "0 0 49 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.756 0.377686H23.7334C23.7334 2.5354 24.5906 4.60474 26.1163 6.13047C27.642 7.6562 29.7114 8.51335 31.8691 8.51335H35.189V11.7189C35.1919 16.208 38.8303 19.8465 43.3195 19.8494V1.94114C43.3195 1.07791 42.6196 0.377686 41.756 0.377686Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8382 9.35742H14.8158C14.8186 13.8466 18.457 17.4851 22.9462 17.488H26.2662V20.7037C26.2719 25.1929 29.9127 28.8289 34.4019 28.8289V10.9212C34.4019 10.0577 33.7018 9.35742 32.8382 9.35742Z",
    fill: "url(#paint0_linear_127_3582)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9157 18.3325H5.89307C5.89307 22.8257 9.53563 26.4682 14.0287 26.4682H17.3591V29.6735C17.3621 34.1585 20.9941 37.7954 25.4792 37.8039V19.8962C25.4792 19.0326 24.7791 18.3325 23.9157 18.3325Z",
    fill: "url(#paint1_linear_127_3582)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.521 44.3953V58.8895C11.521 60.5031 11.0238 61.7976 10.0294 62.7733C9.03493 63.7303 7.72156 64.2087 6.08921 64.2087C4.43809 64.2087 3.11532 63.7208 2.12091 62.7452C1.12648 61.7508 0.629272 60.3998 0.629272 58.6924H3.19038C3.20914 59.6494 3.45305 60.428 3.92212 61.0284C4.40995 61.6288 5.13231 61.929 6.08921 61.929C7.0461 61.929 7.75909 61.6476 8.22816 61.0847C8.69722 60.5031 8.93176 59.7713 8.93176 58.8895V44.3953H11.521Z",
    fill: "#15161A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8892 46.0833C17.4014 46.0833 16.9886 45.9145 16.6508 45.5768C16.3131 45.239 16.1443 44.8263 16.1443 44.3385C16.1443 43.8506 16.3131 43.4378 16.6508 43.1001C16.9886 42.7624 17.4014 42.5935 17.8892 42.5935C18.3582 42.5935 18.7523 42.7624 19.0713 43.1001C19.409 43.4378 19.5778 43.8506 19.5778 44.3385C19.5778 44.8263 19.409 45.239 19.0713 45.5768C18.7523 45.9145 18.3582 46.0833 17.8892 46.0833ZM19.1275 48.5882V64.0111H16.5664V48.5882H19.1275Z",
    fill: "#15161A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0536 51.0936C26.504 50.2118 27.1419 49.527 27.9674 49.0392C28.8118 48.5513 29.8343 48.3074 31.0351 48.3074V50.9529H30.3597C27.489 50.9529 26.0536 52.5102 26.0536 55.6248V64.0117H23.4926V48.5888H26.0536V51.0936Z",
    fill: "#15161A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0347 56.243C33.0347 54.6668 33.3536 53.2878 33.9915 52.1058C34.6294 50.905 35.502 49.9762 36.6089 49.3195C37.7347 48.6628 38.9824 48.3345 40.3521 48.3345C41.703 48.3345 42.8757 48.6253 43.8701 49.2069C44.8646 49.7886 45.6056 50.5204 46.0934 51.4022V48.5877H48.6827V64.0107H46.0934V61.14C45.5869 62.0406 44.827 62.7911 43.8138 63.3915C42.8194 63.9731 41.6561 64.264 40.3239 64.264C38.9543 64.264 37.716 63.9263 36.6089 63.2508C35.502 62.5753 34.6294 61.6278 33.9915 60.4083C33.3536 59.1887 33.0347 57.8002 33.0347 56.243ZM46.0934 56.2711C46.0934 55.1078 45.8589 54.0946 45.3898 53.2316C44.9208 52.3685 44.2829 51.7118 43.476 51.2614C42.688 50.7924 41.8156 50.5579 40.8586 50.5579C39.9018 50.5579 39.0293 50.783 38.2413 51.2333C37.4532 51.6836 36.8247 52.3403 36.3556 53.2034C35.8866 54.0665 35.6521 55.0797 35.6521 56.243C35.6521 57.425 35.8866 58.457 36.3556 59.3388C36.8247 60.2018 37.4532 60.8679 38.2413 61.337C39.0293 61.7873 39.9018 62.0125 40.8586 62.0125C41.8156 62.0125 42.688 61.7873 43.476 61.337C44.2829 60.8679 44.9208 60.2018 45.3898 59.3388C45.8589 58.457 46.0934 57.4343 46.0934 56.2711Z",
    fill: "#15161A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_127_3582",
    x1: 34.0162,
    y1: 9.3888,
    x2: 26.3963,
    y2: 17.3398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_127_3582",
    x1: 25.6095,
    y1: 18.4211,
    x2: 16.7951,
    y2: 27.0933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraLogo2);
export default __webpack_public_path__ + "static/media/jira_logo_2.548f293910d9499069bd86e03ba9f711.svg";
export { ForwardRef as ReactComponent };